import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Destination from "../views/Destination.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: {name : "home", params: {"lang" : "en"}}
  },
  {
    path: "/home/:lang",
    name: "home",
    components: { default: Home }
  },
  {
    path: "/destination/:name/:lang",
    name: "destination",
    component: Destination
  },
  {
    path: "/about",
    name: "about",

    component: () => import("../views/About.vue")
  },
  {
    path: "/thankyou/:lang",
    name: "thankyou",
    component: () => import("../views/Thankyou.vue")
  },
  {
    path: "/dailypointsvalue",
    name: "dailypointsvalue",
    component: () => import("../views/DailyPointsValue.vue")
  }
];

const router = new VueRouter({
  mode: 'history',
  history: true,
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior: function(to) {
    
    
    if (to.hash) {
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          // resolve({ x: 0, y: 5000 })
          resolve({ selector: to.hash, offset: { x: 0, y: 0 } })
        }, 500)
      })
    }
    
  }
});

export default router;
